export default __webpack_public_path__ + "static/media/Namaj_Learning.0254e679.svg";